module.exports = __webpack_public_path__ + "media/images/top/budget_table/corporation_sp-0a2eb6c502dc357bbea541b03bcd4a67.png";